import { useCallContext } from "../../contexts/CallContext";
import { apiCall } from "../../utilities/apiCall";
import { commonConfigUtility } from "../../utilities/CommonConfigUtility";
/**
 * Custom hook for using call services throughout the application
 * @returns {Object} Call service methods
 */
const useCallService = () => {
  const { makeCall, handleEndCall, activeCall, callStatus, callSummary, callDuration, baseURL } = useCallContext()||{};

  /**
   * Initiate an outgoing call
   * @param {string} number - Phone number to call
   * @param {string} name - Name of the contact (optional)
   */
  const initiateCall = (number, name = "Unknown Contact") => {
    if (!number) {
      console.error("Phone number is required to make a call");
      return;
    }
    
    // Create the call object and pass to the context
    const callDetails = {
      number,
      name: name || "Unknown Contact",
    };
    
    makeCall(callDetails);
  };

  /**
   * End the current call
   */
  const endCall = () => {
    handleEndCall();
  };

  /**
   * Check if there's an active call
   * @returns {boolean} True if there's an active call
   */
  const hasActiveCall = () => {
    return !!activeCall;
  };

  /**
   * Get current call status
   * @returns {string} Current call status
   */
  const getCallStatus = () => {
    return callStatus;
  };

  /**
   * Get the call summary if available
   * @returns {string|null} Call summary or null
   */
  const getCallSummary = () => {
    return callSummary;
  };

  const getCallDuration = () => {
    return callDuration;
  };


  const callApiCall = (endpoint = "/", method = "GET", data = {}, apiPath = baseURL) => {
    return apiCall(
      endpoint,
      method,
      data,
      { "Access-Control-Allow-Origin": "*" },
      "no-cache",
      "cors",
      {},
      false,
      apiPath
    )
  }


  return {
    initiateCall,
    endCall,
    hasActiveCall,
    getCallStatus,
    getCallSummary,
    getCallDuration,
    callApiCall,
  };
};

export default useCallService; 

let configurationList;
const getBaseURL = async () => {
  if (!configurationList) {
    configurationList = await commonConfigUtility(6, "openAIConfig");
  }
  return configurationList["AI:URL"];
};
export { getBaseURL };
